<template>
  <InfoWindow
    :options="{
      position,
    }"
    @closeclick="emit('closeclick')"
  >
    <div v-if="details" :class="$style.container">
      <img v-if="details.image" alt="map" :class="$style.image" :src="details.image" />
      <div :class="$style.detail">
        <strong
          v-if="details.firstname"
          :class="$style.space"
          v-html="details.firstname + '&nbsp'"
        />
        <strong v-if="details.lastname" :class="$style.space" v-text="details.lastname" />
        <div v-if="details.position" :class="$style.space" v-text="details.position" />
        <strong v-if="details.company" :class="$style.space" v-text="details.company" />
        <div
          v-if="details.address"
          :class="$style.space"
          v-html="details.address.replace(/\n/g, '<br />')"
        />
        <a v-if="details.email" :href="`mailto:${details.email}`">
          {{ details.email }}
        </a>
        <a v-if="details.phone" :href="`tel:${details.phone}`">
          {{ details.phone }}
        </a>
        <a v-if="details.detailsLink" @click="displayDetails">
          {{ details.detailsLink }}
        </a>
        <a
          v-if="details.jobOffersLink && isJobOfferAvailable"
          :href="details.jobOffersUrl"
          target="_blank"
        >
          {{ details.jobOffersLink }}
        </a>
        <a v-if="useForm && details.formEmail" :href="prepareContactFormUrl(details)">
          {{ storeTranslations.translations?.['dynamicForm'] }}
        </a>
      </div>
    </div>
  </InfoWindow>
</template>

<script setup>
import { InfoWindow } from 'vue3-google-map';
import { computed, ref, watch } from 'vue';
import { prepareContactFormUrl } from '../../utils/form';
import { useStoreTranslations } from '../../store/translations/translations';
import safeFetch from '../../utils/safeFetch';

const props = defineProps({
  position: {
    type: Object,
    default: () => undefined,
  },
  opened: {
    type: Boolean,
    default: false,
  },
  details: {
    type: Object,
    default: () => {},
  },
  options: {
    type: Object,
    default: () => {},
  },
  useForm: {
    type: Boolean,
    default: false,
  },
  jobOfferJsonUrl: {
    type: String,
    default: '',
  },
  filterKeyValue: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['displayDetails', 'closeclick']);

const storeTranslations = useStoreTranslations();

const jobOfferAvailableValue = ref(false);
const jobData = ref(null);

const displayDetails = () => {
  emit('displayDetails', props.details.detailsUrl);
};

const jobOffersAvailable = (url, filterKey, itemValue) => {
  if (itemValue) {
    safeFetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        jobData.value = data.items.filter((item) => item.filterCategories[filterKey] === itemValue);
        jobOfferAvailableValue.value = false;
        if (jobData.value != null && jobData.value.length > 0) {
          jobOfferAvailableValue.value = true;
        }
      })
      .catch((error) => {
        console.error(error);
        return false;
      });
  } else {
    jobOfferAvailableValue.value = true;
  }
};

watch(
  () => [props.jobOfferJsonUrl, props.filterKeyValue, props.details?.jobMappingValue],
  ([url, filterKey, itemValue]) => {
    jobOffersAvailable(url, filterKey, itemValue);
  },
  { immediate: true },
);

const isJobOfferAvailable = computed(() => jobOfferAvailableValue.value);
</script>

<style module lang="scss">
@forward './MapInfoWindow.scss';
</style>
